import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const updateDesignation = createAsyncThunk(
  "updateDesignation",
  async ({ id, data, form, history }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.patch(
      `designation/update?id=${id}`,
      data,
      config
    );

    form.resetFields();
    message.success("Designation successfully updated!");
    history("/app/employee/designation");
    return response.data;
  }
);

const designationUpdateSlice = createSlice({
  name: "designationUpdate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(updateDesignation.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(updateDesignation.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(updateDesignation.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default designationUpdateSlice.reducer;